import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class AddOnFeaturesApi extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'AddOnFeaturess';
  getList = 'list';

  async getListAddOnFeatures() {
    let request = {
      url: [this.getAPIUrl(), this.getList].join('/'),
      data: {
        skip: 0,
        take: 1000,
        sort: '',
        filter: '',
        emptyFilter: '',
        columns:
          'feature_id,package_id,feature_name,feature_price,national',
      },
    };
    var res = httpClient.postAsync(request,false);
    return res;
  }
}

export default new AddOnFeaturesApi();
